import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CategoriesApi } from '@interfaces/categories/categories.enum';
import { NavController } from '@ionic/angular';

enum InputSizes {
  NORMAL = 'normal',
  BIG = 'big',
}

@Component({
  selector: 'app-search-input',
  templateUrl: 'search-input.template.html',
  styleUrls: ['./search-input.style.scss'],
})
export class SearchComponent implements OnInit {
  @Input() placeholder: string = '¿Qué quieres encontrar?';
  @Input() border: boolean = true;
  @Input() size: InputSizes = InputSizes.NORMAL;
  @Input() category: string = '';
  @Input() dontRedirect: boolean = false;
  @Input() keyword: string = '';
  @Output() keywordChanged: EventEmitter<string> = new EventEmitter<string>();

  public searchForm: FormGroup;

  constructor(private navCtrl: NavController, private fb: FormBuilder) {}

  ngOnInit() {
    this.searchForm = this.fb.group({
      keyword: [this.keyword],
    });
  }

  get inputSizes() {
    return InputSizes;
  }

  search() {
    if (!this.searchForm.valid) return;

    const { keyword } = this.searchForm.value;

    this.keywordChanged.emit(keyword);

    if (this.dontRedirect) return;

    let urlSearch = !!this.category
      ? `/public/category/${this.category}`
      : '/public/category';

    urlSearch += `?keyword=${keyword}`;

    this.navCtrl.navigateRoot(urlSearch);
  }
}
